<div class="transfer-details-view-container" *ngIf="receivablesTransferObject" fxLayout="column" fxLayoutGap="15px">

  <div class="status-info">
    <mat-form-field appearance="fill" [ngClass]="'input-color-' + receivablesTransferObject.status.color">
      <mat-label>Status</mat-label>
      <input matInput placeholder="Status" [disabled]="true" [value]="receivablesTransferObject.status?.name">
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutGap="15px">

    <button
      [disabled]="!(userPermissions | async).receivables.delete"
      *ngIf="[RECEIVABLES_TRANSFER_STATUS_TO_BE_COMPLETED].includes(receivablesTransferObject?.status.key)  "
      mat-stroked-button
      (click)="suspendedRow()"
    >
      <span>Wstrzymaj</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.delete  && [RECEIVABLES_TRANSFER_STATUS_SUSPENDED ].includes(receivablesTransferObject?.status.key)"
      mat-stroked-button
      (click)="toBeCompledRow()"
    >
      <span>Do zrealizowania</span></button>

    <button
      *ngIf="(userPermissions | async).receivables.delete && receivablesTransferObject.status.key!==RECEIVABLES_TRANSFER_STATUS_COMPLETED"
      [disabled]="!(userPermissions | async).receivables.delete " (click)="delete()" mat-stroked-button color="warn">
      <mat-icon>delete</mat-icon>
      <span> Usuń</span></button>

    <button
      mat-stroked-button
      [style.visibility]="'hidden'"
    ><span>edit</span></button>

  </div>
  <div fxLayout="row"  fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100"  fxLayoutGap="15px">
      <div fxLayout="row"  fxFlex="100" fxFlex.lt-md="100" >
        <div fxFlex="100">
          <mat-card>
            <div fxLayout="row">
              <h3>Dane</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Nazwa odbiorcy" [value]="receivablesTransferObject.name"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Tytuł przelewu" [value]="receivablesTransferObject.transferTitle"></app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Numer konta" [value]="receivablesTransferObject.accountNumber"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Kwota przelewu">
                  {{ (receivablesTransferObject.transferAmount === null ? 0 : receivablesTransferObject.transferAmount) | number:'1.2-2' }}
                  zł
                </app-detail>
              </div>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="100">
                <app-detail header="Uwagi" [value]="receivablesTransferObject.note"></app-detail>
              </div>

            </div>
          </mat-card>
        </div>
      </div>

      <div fxLayout="row" fxFlex="100"
           *ngIf="receivablesTransferObject.receivablesBankJob">
        <div fxFlex="100" >
          <mat-card>
            <div fxLayout="row">
              <h3>Dane płatności</h3>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Data dodania"
                            [value]="receivablesTransferObject.createdAt| date:'y-MM-dd'"></app-detail>
              </div>

              <div fxFlex="50">
                <app-detail header="Data zrealizowania"
                            [value]="receivablesTransferObject.receivablesBankJob.createdAt| date:'y-MM-dd'"></app-detail>
              </div>
            </div>


          </mat-card>
        </div>
      </div>
    </div>
  </div>
</div>
